import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ControlledCheckbox, ControlledTextField } from 'components/shared';
import CLASelect from 'components/shared/CLASelect/CLASelect';
import ValidityFormElement from 'components/shared/CRUD/components/ValidityFormElement';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

import { EmployerFields } from './components/EmployerFields';
import {
  GridContainer,
  GridCompact12
} from 'components/shared/Grid/Grid.components';

const GeneralSection = () => {
  const { control } = useFormContext();
  const { t } = useTranslation('common', {
    keyPrefix: 'employerCostSettings.details.general'
  });

  return (
    <MultiStepForm.Section title={t('title')}>
      <GridContainer>
        <EmployerFields />
        <GridCompact12>
          <CLASelect />
        </GridCompact12>
        <GridCompact12>
          <ControlledCheckbox
            control={control}
            label={t('default_label')}
            name="flags.DEFAULT"
          />
        </GridCompact12>
        <GridCompact12>
          <ValidityFormElement />
        </GridCompact12>
        <GridCompact12>
          <ControlledTextField
            control={control}
            variant="outlined"
            name="codeExt"
            label={t('external_code_label')}
          />
        </GridCompact12>
        <GridCompact12>
          <ControlledTextField
            control={control}
            variant="outlined"
            name="exportgroupCode"
            label={t('export_group_label')}
          />
        </GridCompact12>
        <GridCompact12>
          <ControlledTextField
            control={control}
            variant="outlined"
            name="invoiceGroup"
            label={t('invoice_group_label')}
          />
        </GridCompact12>
      </GridContainer>
    </MultiStepForm.Section>
  );
};
export default GeneralSection;
